import { SERVICE_PROVIDERS, EspAccount } from 'modules/graphql/types';
import { z } from 'zod';
import { ESP_ACCOUNT_PAYLOAD_FIELDS } from '../../types';
import {
  customEmailCreateAccountSchema,
  genericCreateAccountSchema,
  twilioCreateAccountSchema,
} from '../CreateAccountFormProvider/schemas';

const {
  ID,
  EDIT_SIGNING_SECRET,
  EDIT_API_KEY,
  IS_DEFAULT,
  BINDING,
  API_ENDPOINT,
  SIGNING_SECRET,
  IS_SENDER_ITERABLE,
  EDIT_CLIENT_SECRET,
} = ESP_ACCOUNT_PAYLOAD_FIELDS;

const genericEditFields = z.object({
  [ID]: z.number(),
  [EDIT_API_KEY]: z.boolean(),
  [IS_DEFAULT]: z.boolean(),
});

const genericEditAccountSchema = z.object({
  ...genericCreateAccountSchema.shape,
  ...genericEditFields.shape,
});

const sparkpostEditAccountSchema = z.object({
  ...genericCreateAccountSchema.shape,
  ...genericEditFields.shape,
  [BINDING]: z.string().min(1, { message: 'Enter an IP pool' }),
});

const sparkpostEliteEditAccountSchema = z.object({
  ...genericCreateAccountSchema.shape,
  ...genericEditFields.shape,
  [BINDING]: z.string().min(1, { message: 'Enter an IP pool' }),
  [API_ENDPOINT]: z
    .string()
    .min(1, { message: 'Enter a custom endpoint URL.' })
    .url({ message: 'Enter a valid URL.' }),
});

const telnyxEditAccountSchema = z.object({
  ...genericCreateAccountSchema.shape,
  ...genericEditFields.shape,
  [SIGNING_SECRET]: z.string(),
  [EDIT_SIGNING_SECRET]: z.boolean(),
});

const iterableSmsTelnyxEditAccountSchema = z.object({
  ...telnyxEditAccountSchema.shape,
  [IS_SENDER_ITERABLE]: z.boolean(),
});

const twilioEditAccountSchema = z.object({
  ...twilioCreateAccountSchema.shape,
  ...genericEditFields.shape,
});

const iterableSmsTwilioEditAccountSchema = z.object({
  ...twilioEditAccountSchema.shape,
  [IS_SENDER_ITERABLE]: z.boolean(),
});

const customEmailEditAccountSchema = z.object({
  ...customEmailCreateAccountSchema.shape,
  ...genericEditFields.shape,
  [EDIT_CLIENT_SECRET]: z.boolean(),
});

export const getEditAccountSchema = (espAccount: EspAccount) => {
  const { esp, isSenderIterable } = espAccount;
  switch (esp) {
    case SERVICE_PROVIDERS.DYN:
    case SERVICE_PROVIDERS.MAILGUN:
    case SERVICE_PROVIDERS.MAILGUN_EU:
    case SERVICE_PROVIDERS.SENDGRID:
      return genericEditAccountSchema;
    case SERVICE_PROVIDERS.SPARKPOST:
    case SERVICE_PROVIDERS.SPARKPOST_EU:
      return sparkpostEditAccountSchema;
    case SERVICE_PROVIDERS.SPARKPOST_ELITE:
      return sparkpostEliteEditAccountSchema;
    case SERVICE_PROVIDERS.CUSTOM_MTA:
      return customEmailEditAccountSchema;
    case SERVICE_PROVIDERS.TELNYX:
      return isSenderIterable ? iterableSmsTelnyxEditAccountSchema : telnyxEditAccountSchema;
    case SERVICE_PROVIDERS.TWILIO:
      return isSenderIterable ? iterableSmsTwilioEditAccountSchema : twilioEditAccountSchema;
    default:
      return genericEditAccountSchema;
  }
};
